import { AnyAction } from 'redux';
import { Draft } from '@/types';
import { Thunk } from '@/redux/types';
import { setDraftAction as setDraftStateAction } from '@/components/draft/draftState/actions/setDraftAction';
import { verifyDraft } from '../utils/verifyDraft';

export const setDraftAction =
  (draft: Draft): Thunk<void, AnyAction> =>
  (dispatch, getState) => {
    getState().draftDispatch(setDraftStateAction(draft));

    verifyDraft(draft, dispatch);
  };
